import type { ICreateSurveyAnswerResponse } from "@/types/surveys.types";
import type { SurveyAnswerBody } from "../types/working-model";
import { HvHostMap, PostHvJson } from "./helpers";

export const SubmitSurveyAnswer = async (body: SurveyAnswerBody, token?: string | null) => {
	return PostHvJson<ICreateSurveyAnswerResponse>({ service: HvHostMap.surveys, path: '/e3-submit-survey', data: body, blProfileToken: token || '' });
};
